import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import setLotToAvailable from '../Agreement/setLotToAvailable.api';

const firebaseRef = firebase.database();

export default async function movePurchaserToLead(leadId, salesAgent, lotId) {
	console.log(
		'️‍movePurchaserToLead(leadId, salesAgent, lotId)',
		leadId,
		salesAgent,
		lotId
	);

	const agreementRef = firebaseRef.ref(
		'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
		// +'/clientInfo/individual/0/identification'
	);
	const purchaserRef = firebaseRef.ref(
		'/kavtek_purchasers/' +
			PROJECT_CODE.projectCode +
			'/' +
			salesAgent +
			'/' +
			leadId
	);
	const dealArchiveRef = firebaseRef.ref(
		'/deal_to_lead_archive/' + PROJECT_CODE.projectCode
	);
	await agreementRef.once('value', async (snapshot) => {
		let agreementObj = snapshot.val();

		// 1. Check primary user identification
		let primaryIdentity =
			agreementObj?.clientInfo?.individual?.[0]?.identification;
		let leadDetails = agreementObj?.leadDetails;

		if (primaryIdentity && !leadDetails?.identification) {
			leadDetails['identification'] = primaryIdentity;
		}

		// 2. Back to lead node
		await firebaseRef
			.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
			.update({ [leadId]: leadDetails });

		// 3. Save under archive node
		let dealArchive = dealArchiveRef.push();
		dealArchive.set(agreementObj);
	});
	// 4. Remove from agreement node
	await agreementRef.remove();

	// // @TODO: UNCOMMENT
	await firebaseRef
		.ref(
			'/kavtek_purchasers/' + PROJECT_CODE.projectCode + '/' + salesAgent
		)
		.child(leadId)
		.remove();

	if (lotId) {
		setLotToAvailable(lotId);
		let setLotToAvailableFunc = firebase
			.functions()
			.httpsCallable('setLotToAvailable');
		await setLotToAvailableFunc({
			lotId: lotId,
			projectCode: PROJECT_CODE.projectCode,
		});
	}
}
